import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ArrowBack = ({
  height = 24,
  width = 24,
  color = colors.black,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.9999 11.5332L5.00001 11.5332"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.5334 4.99998L5.00017 11.5333L11.5334 18.0665"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
